export var ERROR_BAD_TOKEN = 'ERROR_BAD_TOKEN';
export var ERROR_VALIDATION_FAILED = 'ERROR_VALIDATION_FAILED';
